var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"echart-line-bar"},[_c('div',{ref:"chart",staticClass:"echart-line-bar-mod",style:({ width: _vm.width, height: _vm.height })})])}
var staticRenderFns = []

export { render, staticRenderFns }